<div>
    <section-header
    sectionTitle="Admin Proxy"
    navPath="/admin-proxy"
    containerClass="container"
    [navLinks]="[]"></section-header>

    <div style="margin-top: 20px;">
        <div class="col-md-3">
            <user-picker
            [formControl]="usersControl"
            (enableNonANRCollaborator)="false"
            [selectSingle]="true"
            [updateUserTableFromDirectory]="false"
            [showUserIds]="true"
            [showDeletedUsers]="true"
            [searchLocalOnly]="true"></user-picker>
        </div>
       <div style="margin-top: 10px;margin-left: 1em;">
        <div>
            <button class="btn btn-primary" style="width:7em;" [disabled]="usersControl.value.toArray().length != 1" (click)="Spoof()" type="submit">
                Admin Proxy
              </button>
        </div>
       </div>
        <div *ngIf="message" class="alert alert-danger mt-3" role="alert" style="margin-left: 1em; max-width: 40em;">
            <i class="fa fa-exclamation-triangle mr-2"></i>{{message}}
        </div>
    </div>
    <div style="margin-top: 14em;">
        <anr-footer></anr-footer>
    </div>
 
</div>

